export default __webpack_public_path__ + "static/custom_templates-c2bf61347af54bef00a03a89c15a66b7.svg";